// extracted by mini-css-extract-plugin
export default {"layoutContainer":"styles_layoutContainer__sS5++","layoutContainer__inner":"styles_layoutContainer__inner__hmWoP"};